import React, { useEffect } from "react";
import { useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";

import { publicationsDb } from "../../../db/dbClasses";
import { getPublicationTypeFrequency } from "../../../utils/generalUtils";
import DropDownComponent from "../../Miscellaneous/DropDown.component";
import { BoxDiv } from "../../Miscellaneous/FancyDiv.component";
import { SortSymbolIcon } from "../../Miscellaneous/Icons.component";
import Header from "../../Miscellaneous/Header.component";
import NumberedList from "../../Miscellaneous/NumberedList.component";

const getDropDownOptions = (typeFreq) => {
  const menuOptions = [];
  const types = Object.keys(typeFreq).sort();
  let total = 0;
  types.forEach((type) => {
    menuOptions.push({
      value: type,
      display: `${type} (${typeFreq[type]})`,
    });
    total += typeFreq[type];
  });
  return [
    {
      value: "All Types",
      display: `All Types (${total})`,
    },
    ...menuOptions,
  ];
};

const filterPublication = (allPublications, type) => {
  if (type === "All Types") return [...allPublications];
  return allPublications.filter((publication) => {
    return publication.type === type;
  });
};

const sortPublication = (allPublications, order) => {
  return [...allPublications].sort((o1, o2) => {
    return order * (o1["year"] - o2["year"]);
  });
};

const PublicationComponent = () => {
  const [allPublications, setAllPublications] = useState([]);
  const [typeFreq, setTypeFreq] = useState({});
  const [selectedPublications, setSelectedPublications] = useState("All Types");
  const [showOrder, setShowOrder] = useState(-1);

  const toggleShowOrder = () => {
    setShowOrder(-1 * showOrder);
  };

  useEffect(() => {
    (async () => {
      const array = await publicationsDb.read();
      const typeFreq = getPublicationTypeFrequency(array);
      setAllPublications(sortPublication(array, -1));
      setTypeFreq(typeFreq);
    })();
  }, []);

  useEffect(() => {
    setAllPublications((allPublications) =>
      sortPublication(allPublications, showOrder)
    );
  }, [showOrder]);

  return (
    <div className="font-open-sans p-0">
      <Header content="Publications" />
      <BoxDiv minHeight={"0"}>
        <div className="m-auto py-4 w-80">
          <Row>
            <Col xs={11} className="pb-1">
              <DropDownComponent
                menuItems={getDropDownOptions(typeFreq)}
                setOption={setSelectedPublications}
              />
            </Col>
            <Col xs={1}>
              <Button
                onClick={() => toggleShowOrder()}
                variant="white"
                className="border border-black-50 rounded"
              >
                <div
                  className=" d-flex align-items-center justify-content-center"
                  style={{
                    transition: "0.3s ease-in-out",
                    transform: showOrder < 0 ? "rotate(180deg)" : "none",
                  }}
                >
                  <SortSymbolIcon fill={"#000000"} />
                </div>
              </Button>
            </Col>
          </Row>
        </div>
        <div
          style={{
            width: "95%",
            margin: "auto",
          }}
        >
          <NumberedList
            list={filterPublication(allPublications, selectedPublications)}
            searchKey={"content"}
            fontWeight="n"
            className="ml-4"
          />
          <p>&nbsp;</p>
        </div>
      </BoxDiv>
    </div>
  );
};

export default PublicationComponent;
